import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';
import bcrypt from 'bcryptjs';

export async function POST(request: NextRequest) {
  try {
    // Check if admin already exists
    const existingAdmin = await db.users.findByEmail('admin@femalefitnessfinder.com');
    
    if (existingAdmin) {
      return NextResponse.json({
        success: false,
        message: 'Admin account already exists',
        admin: {
          email: 'admin@femalefitnessfinder.com',
          password: 'Admin123!'
        }
      });
    }

    // Create default admin account
    const passwordHash = await bcrypt.hash('Admin123!', 10);
    
    const admin = await db.users.createAdmin({
      fullName: 'System Administrator',
      email: 'admin@femalefitnessfinder.com',
      phone: '+447000000000',
      passwordHash: passwordHash,
      role: 'admin',
      status: 'active'
    });

    return NextResponse.json({
      success: true,
      message: 'Default admin account created successfully',
      admin: {
        email: 'admin@femalefitnessfinder.com',
        password: 'Admin123!'
      },
      adminData: {
        id: admin.id,
        fullName: admin.fullName,
        email: admin.email,
        role: admin.role
      }
    });
  } catch (error) {
    console.error('Error creating default admin:', error);
    return NextResponse.json(
      { error: 'Failed to create admin account' },
      { status: 500 }
    );
  }
}

// Also allow GET to check if admin exists
export async function GET() {
  try {
    const existingAdmin = await db.users.findByEmail('admin@femalefitnessfinder.com');
    
    if (existingAdmin) {
      return NextResponse.json({
        exists: true,
        message: 'Admin account exists',
        login: {
          email: 'admin@femalefitnessfinder.com',
          password: 'Admin123!'
        }
      });
    } else {
      return NextResponse.json({
        exists: false,
        message: 'Admin account not created yet',
        login: {
          email: 'admin@femalefitnessfinder.com',
          password: 'Admin123!'
        }
      });
    }
  } catch (error) {
    return NextResponse.json(
      { error: 'Failed to check admin status' },
      { status: 500 }
    );
  }
}
